// Epic 7 re-skin (ADO-903) — PLACEHOLDER sample card values.
//
// The prototype card shows price, RRP and margin.
// Our catalogue read model (`ProductSummary`) does not carry RRP or margin,
// so (per the approved "placeholder sample values" decision) the card fills them
// with DETERMINISTIC sample values derived from the SKU, so the card reads as
// pixel-complete now. These are NOT real data. Replace with real fields when the
// read model gains them (margin/RRP: pricing/merchandising epics). The sample
// multi-buy pill and promo line are deleted (Pricing migration 32, ADO-3985 T10):
// the real deals come from `useMultibuyDealsStore`.
//
// The card's unit price is not here: it reads `provisionalUnitPrice`,
// the figure order-capture locks on a cart line.

export interface SampleCardData {
  readonly rrp: string;
  readonly marginPct: string;
}

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

// Hoisted, not constructed per call: `Intl.NumberFormat` is expensive to build
// and this module is called once per card on every grid render.
const EUR = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
const eur = (n: number): string => EUR.format(n);

/** Deterministic placeholder card data for a SKU (stable across renders). */
export function sampleCardData(sku: string): SampleCardData {
  const h = hash(sku);
  // The placeholder buying price the RRP is derived from. Not returned: the card
  // shows the provisional unit price.
  const price = 1.5 + (h % 1600) / 100; // €1.50–€17.49
  const marginPct = 6 + (h % 1100) / 100; // 6.00–16.99 %
  const rrp = price * (1 + marginPct / 100 + 0.02);
  return {
    rrp: eur(rrp),
    marginPct: marginPct.toFixed(2),
  };
}
